import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import Blogmain from '../../Components/BlogesMain/Blogmain'

const Blog = () => {
  return (
    <>
    <Header />
    <Blogmain />
    <Footer />
    </>
  )
}

export default Blog